<template>
    <div
        ref="genreContainer"
        class="genreContainer"
        style=""
    >
    <v-skeleton-loader v-if="userStore.loadingUserInfo" color="#80808027" width="100%" height="10vh" type="list-item-avatar"></v-skeleton-loader>
    <div v-else style="display: flex; align-items: center; width: 100%; height: 10vh; border-bottom: 1px solid grey; justify-content: left;">
      <img  v-if="userStore.user.name" style="width: 16%; border-radius: 50px; margin: 0 1vw 0 1vw; cursor: pointer;" :src="`https://ui-avatars.com/api/?name=${userStore.user.name}`" alt="" @click="$router.push('/account')">
      <p  v-if="userStore.user.name" style="color: white; font-weight: bold; text-transform: capitalize; font-size: large; cursor: pointer;" @click="$router.push('/account')">{{ userStore.user.name }}</p>
      <div v-if="!userStore.user.name" style="display: flex; width: 40%; justify-content: space-evenly; margin-left: 1vw; color: white;">
        <p @click="$router.push('/login')" style="cursor: pointer;">Login</p>
        <p>/</p>
        <p @click="$router.push('/signup')" style="cursor: pointer;">Signup</p>
      </div>
    </div>
    <div v-if="isLoading" style="height: 60vh; display: flex; align-items: center; justify-content: center;">
      <span class="loader"></span>
    </div>
    <div v-else style="border: 0px solid white; height: 60vh; display: flex; align-items: center; position: relative; justify-content: center;" @mouseenter="hovered = true" @mouseleave="hovered=false">
      <p v-if="!hideLyrics && this.info && this.info.lyrics && this.info.lyrics.length" style="color: white; text-align: center; width: 80%; margin: auto; font-size: xx-large; font-weight: bold;">
        {{ this.info.lyrics[currentLyricIndex]?.text || '♪♪' }}
      </p>
      <div v-else>
        <div v-if="queueStore.queue.length && info.artist?.length" style="border: 0px solid white; width: 90%; margin: auto;">
          <div style="height: 20vh; aspect-ratio: 1/1; margin: auto; border-radius: 10px; position: relative; overflow: hidden;">
            <img loading="lazy" :src="info.artistDetails?.thumbnails[0]?.url || `https://ui-avatars.com/api/?name=${encodeURIComponent(info.artist[0]?.name)}&background=random`" alt="" class="thumbnail" @error="e => e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(info.artist[0]?.name)}`">
          </div>
          <p style="color: white; font-size: x-large; font-weight: bold; margin-top: 1vh;">{{ info.artistDetails?.name || info.artist[0]?.name || info.channelTitle }}</p>
          <p style="color: #ffffff97; font-size: small; cursor: pointer; text-decoration: underline;" @click="$router.push(`/artist/${info.artistDetails.artistId}`)">View artist</p>
        </div>
        <p v-else style="color: white; font-weight: bold; font-size: x-large; margin: 5%;">Play something to see synced lyrics</p>
      </div>
      
      <div v-if="info.lyrics" style="position: absolute; bottom: 0; right: 0; margin: auto; display: flex; align-items: center; justify-content: right; width: 90%;">
        <div @click="toggleLyrics" class="glass" style="width: 35%; border: 1px solid white; padding: 1%; cursor: pointer; margin-right: 1vw;"><p style="font-size: x-small; pointer-events:none" >Show full lyrics</p></div>
        <div style="display: flex; align-items: center; justify-content: space-evenly;">
          <p style="color: white; font-size: small;">Hide lyrics</p>
          <v-switch
            v-model="hideLyrics"
            hide-details
            inset
            density="compact"
            style="scale: 0.5; margin-left: -7%;"
          ></v-switch>
        </div>
      </div>
      <div v-else-if="queueStore.queue.length || queueStore.isPlaying" style="position: absolute; bottom: 0; margin: auto; display: flex; align-items: center;">
        <p style="color: white; font-size: small; margin-bottom: 1vh;">Lyrics not available for this track</p>
      </div>
    </div>

    <div class="genre-grid">
      <div v-for="(row, rowIndex) in genreRows" :key="rowIndex" class="genre-row">
        <div v-for="(genre) in row" :key="genre.name" :class="[
          'genreCard',
          rgenre === genre.name ? 'highlight' : '', rowIndex%2 ? 'odd' : 'even'
        ]" @click="$router.push(`/g/${genre.name}`)">
          <!-- <v-icon size="small">
            {{ genre.icon }}
          </v-icon> -->

          <p>
            {{ genre.name }}
          </p>
        </div>
      </div>
    </div>
    
    </div>
</template>

<script>

import { EventBus } from '@/eventBus';
import { useToast } from 'vue-toastification';
import { useQueueStore } from '../stores/queue';
import { useLyricsStore } from '../stores/lyrics';
import { useUserStore } from '../stores/user';
import { debounce } from 'lodash';
// import { ref } from 'vue';

export default {
  name: "genreComponent",

  setup() {
    const queueStore = useQueueStore();
    const lyricsStore = useLyricsStore();
    const userStore = useUserStore();
    return { queueStore, lyricsStore, userStore };
  },

  computed: {
    rgenre(){
      return this.$route.params.genre;
    },
    genreRows() {
        const rows = [];

        for (let i = 0; i < this.generes.length; i += 2) {
            rows.push(this.generes.slice(i, i + 2));
        }

        return rows;
    }
  },

  data() {
    return {
        toast: useToast(),
        hovered: false,
        hideLyrics: false,
        info: this.queueStore.queue[this.queueStore.isPlayingIndex] || {},
        currentLyricIndex: null,
        isLoading: false,
        generes: [
          {
              name: "Feel-good",
              icon: "mdi-emoticon-happy"
          },
          {
              name: "Relax",
              icon: "mdi-sofa-single"
          },
          {
              name: "Party",
              icon: "mdi-party-popper"
            },
            
            {
                name: "Energise",
                icon: "mdi-lightning-bolt"
            },
            {
              name: "Commute",
              icon: "mdi-bus"
            },
            {
              name:"Sad",
              icon: "mdi-heart-broken"
            },
            {
              name: "Work-out",
              icon: "mdi-dumbbell"
            },
            {
                name: "Romance",
                icon: "mdi-heart"
            },
            {
              name: "Focus",
              icon: "mdi-lightbulb"
            },
            {
              name: "Sleep",
              icon: "mdi-sleep"
            }
        ],
    };
  },

  methods: {
    updateCurrentTime(time) {
      if (!this.info || !this.info.lyrics || !this.info.lyrics.length) return;
      // ── If time is exactly zero, do NOT highlight anything yet ──
      if (time === 0) {
        return;
      }

      const idx = this.info.lyrics.findIndex((line, i) => {
        return (
          line.time <= time &&
          (i === this.info.lyrics.length - 1 || this.info.lyrics[i + 1].time > time)
        );
      });

      if (idx !== -1 && idx !== this.currentLyricIndex) {
        this.currentLyricIndex = idx;
      }
    },
    toggleLyrics() {
      this.queueStore.isLyricsVisible = true;
      if (window.innerWidth < 675 && this.queueStore.isQueueVisible) {
        this.queueStore.isQueueVisible = false;
      }
    },
  },
  activated(){
    if (this.info.id !== this.queueStore.queue[this.queueStore.isPlayingIndex]?.id) {
     this.info = this.queueStore.queue[this.queueStore.isPlayingIndex];
      // if(!this.info.lyrics){
      //   this.hideLyrics = true;
      // }
    }
  },
  mounted() {
    EventBus.on('info', (info) => {
        this.currentLyricIndex = null; // Reset current lyric index on new info
        this.info = info;
        // if(!this.info.lyrics){
        //   this.hideLyrics = true;
        // }
    });
    EventBus.on('updateCurrentTime', (val) => this.updateCurrentTime(val));

    EventBus.on('loading_info_1', () => {
      // this.isLoading = true;
      this.updateLoading(true);
      // if(this.info.id != this.queueStore.queue[this.queueStore.isPlayingIndex]?.id){
      //   this.info.lyrics = null;
      // }
    });
    
    EventBus.on('loading_info_0', () => {
      // this.isLoading = false;
      this.updateLoading(false);
    });

  },

  created() {
      this.updateLoading = debounce((val) => {
          this.isLoading = val;
      }, 500);
  },

  beforeUnmount() {
      this.updateLoading.cancel();
  },

  watch:{
    'queueStore.isLoading'(val){
      this.updateLoading(val);
    }
  }
};
</script>

<style scoped>

.genreContainer {
  right: 0;
  width: 95%;
  height: 98vh;

  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;

  border-radius: 10px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  background: rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);

}

@media screen and (max-width: 675px) {
  .genreContainer {
    width: 100%;
    height: 80vh;
    z-index: 1;
    background-color: #000;
  }
}

.genre-grid {
    width: 100%;
    height: 35vh;
    border: 0px solid white;

    display: flex;
    flex-direction: column;
}


.genre-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 20%;
    /* border: 1px solid white; */
    /* gap: 12px; */

    width: 95%;
    margin: auto;
}


.genreCard {
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    width: fit-content;
    min-width: 0;
    height: 90%;
    cursor: pointer;

    color: white;

    background: rgba(255, 255, 255, 0.06);

    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);

    border: 1px solid rgba(255, 255, 255, 0.06);

    border-radius: 10px;

    box-shadow:
        0 4px 20px rgba(0, 0, 0, 0.12);

    transition:
        background 0.25s ease,
        transform 0.25s ease,
        border-color 0.25s ease;
}


.genreCard p {
    width: fit-content;

    margin: 0;

    color: white;

    font-size: small;

    font-weight: bold;

    white-space: nowrap;
}


.genreCard::before {
    content: "";

    position: absolute;
    inset: 0;

    background: rgba(255, 255, 255, 0.07);

    opacity: 0;

    transition: opacity 0.25s ease;

    pointer-events: none;
}

.genreCard:hover::before {
    opacity: 1;
}

/* Feel-good */
.genre-row:nth-child(1) .genreCard:nth-child(1) {
    background: rgba(105, 165, 225, 0.45);
}

/* Relax */
.genre-row:nth-child(1) .genreCard:nth-child(2) {
    background: rgba(175, 135, 205, 0.40);
}


/* Party */
.genre-row:nth-child(2) .genreCard:nth-child(1) {
    background: rgba(235, 115, 85, 0.45);
}

/* Energise */
.genre-row:nth-child(2) .genreCard:nth-child(2) {
    background: rgba(65, 175, 165, 0.42);
}


/* Commute */
.genre-row:nth-child(3) .genreCard:nth-child(1) {
    background: rgba(225, 175, 95, 0.42);
}

/* Sad */
.genre-row:nth-child(3) .genreCard:nth-child(2) {
    background: rgba(125, 135, 205, 0.42);
}


/* Work-out */
.genre-row:nth-child(4) .genreCard:nth-child(1) {
    background: rgba(90, 175, 125, 0.40);
}

/* Romance */
.genre-row:nth-child(4) .genreCard:nth-child(2) {
    background: rgba(220, 125, 155, 0.40);
}


/* Focus */
.genre-row:nth-child(5) .genreCard:nth-child(1) {
    background: rgba(105, 105, 200, 0.42);
}

/* Sleep */
.genre-row:nth-child(5) .genreCard:nth-child(2) {
    background: rgba(145, 125, 195, 0.48);
}

.genre-row:last-child{
  margin-bottom: 0.5vh;
}

.highlight {
    border: 2px solid rgba(255, 255, 255, 0.55);
    background: rgba(255, 255, 255, 0.12);
}

.odd:nth-child(1){
  min-width: 43%;
}

.odd:nth-child(2){
  min-width: 55%;
}

.even:nth-child(1){
  min-width: 55%;
}

.even:nth-child(2){
  min-width: 43%;
}


@media screen and (max-width: 675px) {
  .queueContainer {
    width: 100%;
    height: 80vh;
    z-index: 2;
    background-color: #000;
  }
  
}
</style>